export {
  TopClassesPage as default,
  getStaticProps,
  getStaticPaths
} from "../../wrappers/TopClassesPage";

// const Details = () => {
//   return (
//     <div>
//       <h1>dfgdfgdfg</h1>
//     </div>
//   );
// };

// export default Details;
